import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import taskModule from './api/taskModule'
import Chance from 'chance'
import project from '../package.json'


// old
// import cue1 from './assets/A_090_2c.png'
// import cue2 from './assets/B_000_2c.png'
// import cue3 from './assets/B_010_2c.png'
// import cue4 from './assets/B_020_2c.png'
// import cue5 from './assets/B_030_2c.png'
// import cue6 from './assets/B_330_2c.png'
// import cue7 from './assets/B_340_2c.png'
// import cue8 from './assets/B_350_2c.png'

// old oct 6, 2021
//import cue1 from './assets/A_100_4c.png'
//import cue2 from './assets/B_010_4c.png'
//import cue3 from './assets/B_020_4c.png'
//import cue4 from './assets/B_030_4c.png'
//import cue5 from './assets/B_040_4c.png'
//import cue6 from './assets/B_340_4c.png'
//import cue7 from './assets/B_350_4c.png'
//import cue8 from './assets/B_360_4c.png'

/* old 10-8-21
import cue1 from './assets/A_100_2c.png'
import cue2 from './assets/B_010_2c.png'
import cue3 from './assets/B_020_2c.png'
import cue4 from './assets/B_030_2c.png'
import cue5 from './assets/B_040_2c.png'
import cue6 from './assets/B_340_2c.png'
import cue7 from './assets/B_350_2c.png'
import cue8 from './assets/B_360_2c.png'
*/

import cue1 from './assets/A_100_4c.png'
import cue2 from './assets/B_010_4c.png'
import cue3 from './assets/B_020_4c.png'
import cue4 from './assets/B_030_4c.png'
import cue5 from './assets/B_040_4c.png'
import cue6 from './assets/B_330_4c.png'
import cue7 from './assets/B_340_4c.png'
import cue8 from './assets/B_350_4c.png'







// old
// import probe1 from './assets/X_45_1c.png'
// import probe2 from './assets/Y_20_1c.png'
// import probe3 from './assets/Y_25_1c.png'
// import probe4 from './assets/Y_30_1p1c.png'
// import probe5 from './assets/Y_35_1p2c.png'
// import probe6 from './assets/Y_40_1p3c.png'
// import probe7 from './assets/Y_50_1p3c.png'
// import probe8 from './assets/Y_55_1p2c.png'
// import probe9 from './assets/Y_60_1p1c.png'
// import probe10 from './assets/Y_65_1c.png'
// import probe11 from './assets/Y_70_1c.png'



// old oct 6, 2021
//import probe1 from './assets/X_055_2c.png'
//import probe2 from './assets/Y_030_2c.png'
//import probe3 from './assets/Y_035_2p1c.png'
//import probe4 from './assets/Y_040_2p2c.png'
//import probe5 from './assets/Y_045_2p3c.png'
//import probe6 from './assets/Y_050_2p6c.png'
//import probe7 from './assets/Y_060_2p6c.png'
//import probe8 from './assets/Y_065_2p3c.png'
//import probe9 from './assets/Y_070_2p2c.png'
//import probe10 from './assets/Y_075_2p1c.png'
//import probe11 from './assets/Y_080_2c.png'

// odl 10-8-21
/*
import probe1 from './assets/X_055_1c.png'
import probe2 from './assets/Y_030_1c.png'
import probe3 from './assets/Y_035_1p1c.png'
import probe4 from './assets/Y_040_1p2c.png'
import probe5 from './assets/Y_045_1p3c.png'
import probe6 from './assets/Y_050_1p6c.png'
import probe7 from './assets/Y_060_1p6c.png'
import probe8 from './assets/Y_065_1p3c.png'
import probe9 from './assets/Y_070_1p2c.png'
import probe10 from './assets/Y_075_1p1c.png'
import probe11 from './assets/Y_080_1c.png'
*/

import probe1 from './assets/X_055_3c.png'
import probe2 from './assets/Y_024_2c.png'
import probe3 from './assets/Y_032_1p9c.png'
import probe4 from './assets/Y_040_1p8c.png'
import probe5 from './assets/Y_070_1p8c.png'
import probe6 from './assets/Y_078_1p9c.png'
import probe7 from './assets/Y_086_2c.png'



import correctAudio from './assets/correct.wav'
import incorrectAudio from './assets/wrong.wav'
import noResponseAudio from './assets/no_resp.wav'

const chance = new Chance()

Vue.use(Vuex)


////////////////////
// ONLY FOR TESTING
var ax = 0;
var ay = 0;
var bx = 0;
var by = 0;
// END ONLY FOR TESTING
///////////////////////

///////////////////////
//
// Required proportions:
// 120 A-X trials (68%)
// 25 A-Y trials (14%)
// 25 B-X trials (14%)
// 5 B-Y trials (5%) 
//
//////////////////////


// defines the trial proportions
// 3 A,X are no longer added in front (see shuffle function): // old: only add 61 trials since 3 A,X trials will be added to the front
var TRIAL_PROPORTIONS = []
var TRIAL_PROPORTIONS_LENGTH = 1
let outcome = []

//while (TRIAL_PROPORTIONS_LENGTH <= 60) {
while (TRIAL_PROPORTIONS_LENGTH <= 100) {
  
  if(TRIAL_PROPORTIONS_LENGTH <= 68){
    outcome = [['A', 'X']]
    ax += 1;
  }else if(TRIAL_PROPORTIONS_LENGTH <= 82){
    outcome = [['A', 'Y']]
    ay += 1;
  }else if(TRIAL_PROPORTIONS_LENGTH <= 96){
    outcome = [['B', 'X']]
    bx += 1;
  }else{
    outcome = [['B', 'Y']]
    by += 1;
  }
  
  /*
  // The weighted probability is dicussed in the README
  let outcome = chance.weighted([
                                  [['A', 'X']], 
                                  [['A', 'Y'], ['A', 'X']], 
                                  [['B', 'X'], ['A', 'X']], 
                                  [['B', 'Y'], ['A', 'X']]], [22.6, 8, 8, 3.2])

  // Makes sure that there are exactly 61 trials
  // if (TRIAL_PROPORTIONS_LENGTH === 60) {
  if (TRIAL_PROPORTIONS_LENGTH === 171) {
      outcome = [['A', 'X']]
  }
  */

  TRIAL_PROPORTIONS_LENGTH += 1 //outcome.length
  TRIAL_PROPORTIONS.push(outcome)
}




  //////////////////////
  // ONLY FOR TESTING
  // console.log(`Trials: ${TRIAL_PROPORTIONS}`)
  /*
  var total = ax + ay + bx + by;
  console.log(`Total: ${total}`)
  console.log(`Proportion a-x (${ax}): ${ax/total}`)
  console.log(`Proportion a-y (${ay}): ${ay/total}`)
  console.log(`Proportion b-x (${bx}): ${bx/total}`)
  console.log(`Proportion b-y (${by}): ${by/total}`)
  */
  // END ONLY FOR TESTING
  //////////////////////

console.log(TRIAL_PROPORTIONS_LENGTH)
console.log(TRIAL_PROPORTIONS)


// set of cue images
const CUES = {
  cue1,
  cue2,
  cue3,
  cue4,
  cue5,
  cue6,
  cue7,
  cue8
}

// set of probe images
const PROBES = {
  probe1,
  probe2,
  probe3,
  probe4,
  probe5,
  probe6,
  probe7
}
/*
,
  probe8,
  probe9,
  probe10,
  probe11
}
*/

const AUDIO = {
  correctAudio,
  incorrectAudio,
  noResponseAudio
}

const state = { // global state of the task
  runId: undefined, // the Id used to identify this run
  token: undefined, // token used to authenticate
  returnTo: undefined, // url of location to return upon completion
  workerId: undefined,
  task: undefined, // task ID assigned from TRiCAM Router
  version: project.version,
  userAgent: navigator.userAgent,
  screenHeight: window.innerHeight,
  screenWidth: window.innerWidth,
  trials: [], // array of trials to be peformed
  training_trials: [['A', 'X'],['A', 'X'],['A', 'X'],['A', 'Y'],['A', 'X'],['B', 'X'],['A', 'X'],['A', 'X'],['B', 'X'],['A', 'X']],
  A: 'cue1', // the key for the A cue in CUES
  B: undefined, // the key for the B cue in CUES
  X: 'probe1', // the key for the X probe in PROBES
  Y: undefined, // the key for the Y probe in PROBES
  incorrectBCue: 'cue2', // for instruction pages, this image is incorrect
  incorrectYProbe: 'probe7', // for instruction pages, this image is incorrect
  trial: [], // the current trial; contains they cue and probe keys
  outcome: null, // message to display on the outcome state
  blocksCompleted: 0, // total number of blocks completed
  trialsCompleted: 0, // counter to keep track of which trial a response is part of
  correctOutcomeCount: 0,
  CUES, // set of cue images
  PROBES, // set of probe images
  AUDIO, // AUDIO
  remaining_time: 0, // remaining time from responses to add the the final fixation
  temp_remaining_time: 0, // used to determined if cue or probe answered prior to focus
  intertrial_start_time: undefined, // Start time for cue
  parameters: { // parameters for the task
    blocks: 2, // number of blocks the subject will need to complete
    cue_response_bucket: 850, // amount of time to respond to the cue
    isi_uniform_distribution: [800,900,1000,1100,1200,1300,1400], // this is to jitter he cue fixation duration
    cue_duration: 250, // the amount of time, in ms, to display the cue
    cue_fixation_duration: 1600, // the amount of time, in ms, to display the fixation
    probe_response_bucket: 850, // amount of time to respond to the probe
    probe_duration: 250, // the amount of time, in ms, to display the probe
    probe_fixation_duration_jitter: [800,900,1000,1100,1200,1300,1400],
    probe_fixation_duration: 1350, // the amount of time, in ms, to display the fixation, this is now jittered (see ablove) so set here just as a default
    outcome_duration_jitter: [300,400,500,600,700],
    outcome_duration: 500, // the amount of time, in ms, to display the outcome
    outcome_fixation_duration: 1200
  },
  lastApiResponse: undefined, // last response from the TRiCAM API
  rng: undefined,
  training_finished: 0
}

const modules = {
  taskModule
}

export const mutations = { // methods that change the state
  init (state, { runId, token, returnTo, task, workerId, key}) {
    // put parameters into state
    state.runId = runId
    state.token = token
    state.returnTo = returnTo
    state.task = task
    state.workerId = workerId
    state.key = key

    console.log(`Task: ${task} Worker: ${workerId} Key: ${key} Run: ${runId} Token: ${token}`)

    // get the keys of the CUES and PROBES
    const cues = _.keys(CUES)
    const probes = _.keys(PROBES)
    state.B = _.sample(_.without(cues, state.A)) // select the B cue at random, excluding the cue selected as A
    state.Y = _.sample(_.without(probes, state.X)) // select the Y probe at random, excluding the probe select as X
  
    var seedrandom = require('seedrandom')
    state.rng = seedrandom('p50')
  
  },
  shuffle (state) { // set the trials in state by shuffling the trial proportions and starting with 3 AX trials
    //////
    // original:
    // let trials = [['A', 'X'], ['A', 'X'], ['A', 'X']]
    // as of 6/28/21:
    let trials = [] 
    Array.prototype.push.apply(trials, _.shuffle(TRIAL_PROPORTIONS).flat())
    state.trials = trials
    console.log(state.trials)
  },
  next (state) { 
    state.parameters.cue_fixation_duration = state.parameters.isi_uniform_distribution[Math.floor(Math.random()*state.parameters.isi_uniform_distribution.length)];
    state.parameters.outcome_duration = state.parameters.outcome_duration_jitter[Math.floor(state.rng()*state.parameters.outcome_duration_jitter.length)];
    state.parameters.probe_fixation_duration = state.parameters.probe_fixation_duration_jitter[Math.floor(state.rng()*state.parameters.probe_fixation_duration_jitter.length)];
    state.trial = state.trials.shift()
    const cues = _.keys(CUES)
    const probes = _.keys(PROBES)
    state.B = _.sample(_.without(cues, state.A)) // select the B cue at random, excluding the cue selected as A
    state.Y = _.sample(_.without(probes, state.X)) // select the Y probe at random, excluding the probe select as X
    state.trialsCompleted += 1
  }, // set the current trial by picking the first value from list
  nextBlock (state) { state.blocksCompleted += 1 }, // increment to the next block
  outcome (state, outcome) { state.outcome = outcome }, // set the outcome in the state
  incrementCorrectOutcomeCount(){ state.correctOutcomeCount++ }, // used at the end to calculate reward money
  addRemainingTime (state, remaining_time) { state.remaining_time += remaining_time }, // add remaining time of one iteration
  clearRemainingTime (state) { state.remaining_time = 0 }, // reset time for iteration
  setStartTime (state) { state.intertrial_start_time = Date.now() },
  tempRemainingTime (state, temp_remaining_time) { state.temp_remaining_time = temp_remaining_time },
  apiResponse (state, response) {state.lastApiResponse = response},
  increment_training (state) {state.training_finished += 1},
  restart_training (state) {state.training_finished = 0}
}

export const getters = {
  getACue: state => state.CUES[state.A], // returns the A cue image
  getBCue: state => state.CUES[state.B], // returns the B cue image
  getXProbe: state => state.PROBES[state.X], // returns the X probe image
  getYProbe: state => state.PROBES[state.Y], // returns the Y probe image
  getTrialCue: state => state.CUES[state[state.trial[0]]], // returns the current trial cue
  getTrialProbe: state => state.PROBES[state[state.trial[1]]], // returns the current trial probe
  getIncorrectBCue: state => state.CUES[state.incorrectBCue],
  getIncorrectYProbe: state => state.PROBES[state.incorrectYProbe],
  getCorrectAudio: state => state.AUDIO['correctAudio'],
  getIncorrectAudio: state => state.AUDIO['incorrectAudio'],
  getNoResponseAudio: state => state.AUDIO['noResponseAudio'],
  getTrialCues: state => state.CUES,
  getTrialProbes: state => state.PROBES,
  getTrainingTrial: state => state.training_trials[state.training_finished]
}

export const actions = {
  init ({ state, dispatch, commit }, { runId, token, returnTo, task, workerId, key}) {
    commit('init', { runId, token, returnTo, task, workerId, key})
    // log the intitial state and parameters
    dispatch('log', { action_type: 'INITIALIZE', payload: _.omit(state, [ 'CUES', 'PROBES', 'AUDIO', 'temp_remaining_time' ]) })
  },
  shuffle ({ commit }) {
    // shuffle the trials from the trial proportions
    commit('shuffle')
  },
  log ({ dispatch, state }, { action_type, payload }) {
    // pick the values from state that should be included in the result payload
    const statePayload = _.pick(state, [ 'trial', 'outcome', 'blocksCompleted', 'trialsCompleted','workerId', 'task' ])
    var cp = { cue: this.getters.getTrialCue, probe: this.getters.getTrialProbe }
    // send the details to be saved as a result
    dispatch('result', { action_type, payload: { ...payload, ...statePayload, ...cp } })
  },
  training_log ({ dispatch, state }, { action_type, payload }) {
    // pick the values from state that should be included in the result payload
    // const statePayload = _.pick(state, [ 'trial', 'outcome', 'blocksCompleted', 'trialsCompleted','workerId', 'task' ])
    const statePayload = _.pick(state, [ 'workerId', 'task' ])
    // state.final_output.push({ ...payload, ...statePayload })
    // send the details to be saved as a result
    dispatch('result', { action_type, payload: { ...payload, ...statePayload } })
  },
  endTask ({ dispatch, state }) {
    // pick the values from state that should be included in the end payload
    // const amountEarned = 0 //{ amountEarned: this.getters.getAmountEarned }
    const payload = _.pick(state, [ 'correctOutcomeCount', 'trialsCompleted','workerId', 'task' ])
    // send the details to be saved as an end notification
    dispatch('end', { payload: { ...payload}}) // , ...amountEarned } })
  },
  untimed_training_response ({ dispatch, commit, state }, { r, counter_all, correct_all, correct_bx, response_state, outcome }) {
    dispatch('training_log', { action_type: 'UNTIMED_TRAINING_RESPONSE', payload: { outcome: outcome, counter_all: counter_all, correct_all: correct_all, correct_bx: correct_bx, response: r, response_state: response_state } }) 
  },
  training_response ({ dispatch, commit, state }, { r, remaining_time, start_time, response_time, end_time, response_state, outcome }) {
    dispatch('training_log', { action_type: 'TRAINING_RESPONSE', payload: { outcome: outcome, start_time: start_time, response_time: response_time, end_time: end_time, response: r, response_state: response_state } }) 
  },
  response ({ dispatch, commit, state }, { r, remaining_time, start_time, response_time, end_time, response_state }) { // record the response from the Probe state
    const isTargetState = _.isEqual(state.trial, ['A', 'X']) // true if target state
    if (r === 'timeout' || state.outcome === 'Respond Faster') {
      commit('outcome', 'Respond Faster')
      commit('tempRemainingTime', remaining_time)
    } else if (r) { // there was a reponse
      const key = parseInt(r, 10) // 37 left, 38 up, 39 right
      if ((response_state === 'cue') || (response_state === 'cue_focus' && state.remaining_time === 0)) {
        if (key === 37) { // The only correct response
          commit('outcome', 'Correct')
        } else {
          commit('outcome', 'Incorrect')
        }
        commit('tempRemainingTime', remaining_time)
      } else if (response_state === 'probe' || response_state === 'probe_focus'){ //(response_state === 'probe_focus' && state.remaining_time === 0)) {
        // if (state.outcome === 'Respond Faster'){
        //  commit('outcome', 'Respond Faster')
        //} else if (state.outcome === 'Incorrect') {
        //  commit('outcome', 'Incorrect')
        if (state.outcome === 'Respond Faster' || state.outcome === 'Incorrect') { // do nothing
        } else if (isTargetState && key === 38) { // up for target
          commit('outcome', 'Correct')
          commit('incrementCorrectOutcomeCount')
        } else if (!isTargetState && key === 39) { // Right for non target
          commit('outcome', 'Correct')
          commit('incrementCorrectOutcomeCount')
        } else { // Incorrect for any other state
          commit('outcome', 'Incorrect')
        }
      }
      commit('tempRemainingTime', remaining_time)
    } else {
      // no reponse
      commit('tempRemainingTime', remaining_time)
    }
    // Add remining time to append to the end to ensure consistant time for trails
    commit('addRemainingTime', remaining_time)
    // save the response as a result
    dispatch('log', { action_type: 'RESPONSE', payload: { start_time: start_time, response_time: response_time, end_time: end_time, response: r, response_state: response_state } })
  },
  next ({ commit }) { // moves to the next trial
    commit('next')
    commit('outcome', null) // resets outcome message
  },
  nextBlock ({ commit }) { // increment to the next block
    commit('nextBlock')
  },
  setStartTime ({ commit }) {
    commit('setStartTime')
  },
  increment_training ({commit,state}) {
   commit('increment_training')
  },
  restart_training ({commit,state}) {
    commit('restart_training')
  },
  sendCompletionMessage ({ commit, state }) {
    this.dispatch('endTask')
    fetch('https://router.tricam.psych.umn.edu/p50/task/' + state.task, {
      method: "POST",
      cache: "no-cache",
      body: JSON.stringify({"status": "COMPLETED", "task": state.task, "worker_id": state.workerId, "payload": {"run_id": state.runId, "token": state.token}}),
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-API-TOKEN": "1co7pzLkZ4Hz"
      }
    }).then(response => {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      commit('apiResponse', response.json());
    })
 },
}

export default new Vuex.Store({
  state,
  modules,
  mutations,
  getters,
  actions
})
